/* ============================================================
   NAVA DECOR — Lighting Signature quiz
   Ported 1:1 from design/Lighting Signature.dc.html (scoring
   weights, archetype copy, demo fixtures) + LSFlow/LSResult.

   Archetype copy lives HERE, beside the weights, so the two can
   never drift. Liquid owns the curated product grids (real store
   data) — see sections/nava-quiz.liquid.

   State: localStorage `nava.quiz.v1` =
     { arch, room, stage, palette:[{name,color}], subscribed, ts }
   A successful email submit also writes the popup's suppression
   key `nava.popup.v1` = { status:'subscribed' } so quiz converts
   are never shown the email popup again.

   Deep links: ?sig=<archetype-slug> renders the shared (static)
   result — no quiz state, no email block, "Find your own" CTA.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-nvq]');
  if (!root) return;

  var IMG = window.NVQ_IMG || {};
  function bgLayers(id, grad) {
    /* photo layered over its gradient — gradient shows while the photo loads */
    if (IMG[id]) return "background-image:url('" + IMG[id] + "')," + grad + ';';
    return 'background:' + grad + ';';
  }

  var KEY = 'nava.quiz.v1';
  var POPUP_KEY = 'nava.popup.v1';
  var TOTAL = 7;

  /* ── instrumentation ──
     Anonymous funnel → Microsoft Clarity custom events/tags (guarded; no-ops if
     Clarity isn't loaded), so completion/drop-off is measurable without a backend.
     Identified milestones (email submit OR a logged-in customer) → Klaviyo, so
     completion is countable in the metrics dashboard and can trigger flows. */
  var COMPANY = root.dataset.company;
  var firedComplete = false; // fire the identified Klaviyo completion once per load
  function clarityCall() {
    try { if (typeof window.clarity === 'function') window.clarity.apply(null, arguments); } catch (e) {}
  }
  function track(step, extra) {
    clarityCall('event', 'nvq_' + step);
    clarityCall('set', 'nvq_step', step);
    if (extra && extra.archetype) clarityCall('set', 'nvq_archetype', extra.archetype);
  }
  function klHeaders() { return { 'Content-Type': 'application/json', 'revision': '2026-07-15' }; }
  function klProfile(email, props) {
    if (!email) return;
    fetch('https://a.klaviyo.com/client/profiles/?company_id=' + COMPANY, {
      method: 'POST', headers: klHeaders(),
      body: JSON.stringify({ data: { type: 'profile', attributes: { email: email, properties: props } } })
    }).catch(function () {});
  }
  function klEvent(email, name, props) {
    if (!email) return;
    fetch('https://a.klaviyo.com/client/events/?company_id=' + COMPANY, {
      method: 'POST', headers: klHeaders(),
      body: JSON.stringify({ data: { type: 'event', attributes: {
        metric: { data: { type: 'metric', attributes: { name: name } } },
        properties: props,
        profile: { data: { type: 'profile', attributes: { email: email } } }
      } } })
    }).catch(function () {});
  }
  function completionProps() {
    var saved = read() || {};
    return {
      lighting_signature: ARCH[state.resultKey].slug,
      quiz_room: state.answers.length ? answerId(5) : (saved.room || ''),
      quiz_stage: state.answers.length ? answerId(6) : (saved.stage || '')
    };
  }

  /* ── data (ported verbatim from the design) ── */
  var G = {
    candle: 'radial-gradient(120% 110% at 58% 44%, #5a3e1c 0%, #2c2013 55%, #211C16 100%)',
    airy: 'radial-gradient(120% 110% at 52% 30%, #f6f1e6 0%, #CFC3A8 58%, #B6A484 115%)',
    crystal: 'radial-gradient(120% 110% at 50% 28%, #f2ecdf 0%, #d6ccbc 55%, #ab9d82 115%)',
    alab: 'radial-gradient(120% 110% at 55% 36%, #ece4d2 0%, #d3c7ac 60%, #b0a284 115%)',
    brass: 'radial-gradient(120% 110% at 52% 34%, #ddba76 0%, #a07c44 55%, #47381e 115%)',
    steel: 'radial-gradient(120% 110% at 55% 34%, #757370 0%, #3b3934 55%, #191813 115%)',
    sculpt: 'radial-gradient(120% 110% at 52% 30%, #e6dfce 0%, #cbbfa4 55%, #968c74 115%)',
    classic: 'radial-gradient(120% 110% at 55% 42%, #443a2b 0%, #2a2318 55%, #211C16 110%)',
    statement: 'radial-gradient(120% 110% at 55% 30%, #e0a54c 0%, #6e5228 48%, #211C16 112%)',
    layered: 'radial-gradient(90% 90% at 28% 72%, #d9b978 0%, transparent 42%), radial-gradient(85% 85% at 76% 38%, #c99a55 0%, transparent 46%), linear-gradient(160deg, #2a2218, #211C16)',
    rDining: 'radial-gradient(120% 110% at 55% 40%, #6e5228 0%, #3a2c18 60%, #211C16 115%)',
    rLiving: 'radial-gradient(120% 110% at 52% 34%, #d8ccb0 0%, #B6A484 60%, #8c7355 118%)',
    rBedroom: 'radial-gradient(120% 110% at 55% 38%, #cdbf9f 0%, #b0a082 58%, #6e5c40 118%)',
    rEntry: 'radial-gradient(120% 110% at 55% 40%, #8c7355 0%, #4a3a28 60%, #211C16 115%)',
    rBath: 'radial-gradient(120% 110% at 52% 34%, #d6d2c4 0%, #9faaa6 62%, #55605c 118%)'
  };

  var QUESTIONS = [
    { kind: 'pair', title: 'Which room feels like yours?', sub: 'Pair 1 of 5 · the same room, two moods',
      options: [
        { id: 'candle', kicker: 'By candlelight', label: 'Warm, close, low-lit', grad: G.candle, swatch: { name: 'Candlelight', color: '#C98A45' }, w: { ec: 2, cl: 1, gr: 1 } },
        { id: 'airy', kicker: 'Sun-washed', label: 'Open, bright, morning air', grad: G.airy, swatch: { name: 'Daylight', color: '#EFE7D6' }, w: { ls: 2, wm: 1 } }
      ] },
    { kind: 'pair', title: 'Reach out and touch —', sub: 'Pair 2 of 5 · material up close',
      options: [
        { id: 'crystal', kicker: 'Cut crystal', label: 'Faceted, catching light', grad: G.crystal, swatch: { name: 'Crystal', color: '#DCCFC0' }, w: { gr: 2, ec: 1 } },
        { id: 'alab', kicker: 'Hand-poured alabaster', label: 'Lit from within, soft', grad: G.alab, swatch: { name: 'Alabaster', color: '#E4DAC6' }, w: { wm: 2, ls: 1 } }
      ] },
    { kind: 'pair', title: 'The finish you keep coming back to', sub: 'Pair 3 of 5 · metal detail',
      options: [
        { id: 'brass', kicker: 'Polished brass', label: 'Warm, glinting, gilded', grad: G.brass, swatch: { name: 'Aged brass', color: '#B08D4C' }, w: { cl: 2, gr: 1 } },
        { id: 'steel', kicker: 'Blackened steel', label: 'Matte, graphite, quiet', grad: G.steel, swatch: { name: 'Blackened steel', color: '#3A342C' }, w: { sm: 2, ec: 1 } }
      ] },
    { kind: 'pair', title: 'The silhouette that stops you', sub: 'Pair 4 of 5 · form',
      options: [
        { id: 'sculpt', kicker: 'Sculptural, now', label: 'A contemporary gesture', grad: G.sculpt, swatch: { name: 'Clear acrylic', color: '#D9CFC4' }, w: { sm: 2, wm: 1 } },
        { id: 'classic', kicker: 'Classical, heritage', label: 'A form that outlasts', grad: G.classic, swatch: { name: 'Patina', color: '#6E8B86' }, w: { cl: 2, gr: 1 } }
      ] },
    { kind: 'pair', title: 'How should the light arrive?', sub: 'Pair 5 of 5 · the whole room',
      options: [
        { id: 'statement', kicker: 'One statement', label: 'A single chandelier', grad: G.statement, swatch: { name: 'Amber glow', color: '#B87A3C' }, w: { gr: 2, ec: 1 } },
        { id: 'layered', kicker: 'Layered & quiet', label: 'Several soft sources', grad: G.layered, swatch: { name: 'Soft glow', color: '#EAD9B8' }, w: { wm: 2, ls: 1 } }
      ] },
    { kind: 'grid', title: 'Which room are we lighting?', sub: 'Question 6 of 7',
      options: [
        { id: 'dining', label: 'Dining', grad: G.rDining, swatch: { name: 'Dining', color: '#6E5228' }, w: { ec: 1, gr: 1 } },
        { id: 'living', label: 'Living', grad: G.rLiving, swatch: { name: 'Living', color: '#B6A484' }, w: { wm: 1, cl: 1 } },
        { id: 'bedroom', label: 'Bedroom', grad: G.rBedroom, swatch: { name: 'Bedroom', color: '#CFC3A8' }, w: { wm: 1, ls: 1 } },
        { id: 'entry', label: 'Entry & stair', grad: G.rEntry, swatch: { name: 'Entry', color: '#8C7355' }, w: { gr: 1, sm: 1 } },
        { id: 'bath', label: 'Bath', grad: G.rBath, swatch: { name: 'Bath', color: '#9FAAA6' }, w: { ls: 1, sm: 1 } }
      ] },
    { kind: 'stage', title: 'Where are you in the project?', sub: 'Last one',
      options: [
        { id: 'dream', label: 'Just dreaming', sub: 'Gathering ideas, no rush.', swatch: { name: 'Dreaming', color: '#CFC3A8' }, w: { ls: 1, ec: 1 } },
        { id: 'reno', label: 'Renovating now', sub: 'Walls are open — decisions due.', swatch: { name: 'Renovating', color: '#8C7355' }, w: { sm: 1, cl: 1 } },
        { id: 'finish', label: 'Finishing touches', sub: 'The room is nearly there.', swatch: { name: 'Finishing', color: '#B08D4C' }, w: { wm: 1, gr: 1 } }
      ] }
  ];

  var ARCH = {
    wm: { key: 'wm', slug: 'warm-minimalist', name: 'The Warm Minimalist', edition: 'No. 01 of 06', moodShort: 'Warm Minimalist', mood: 'warm-minimal',
      tagline: 'Alabaster calm — held quiet.',
      description: 'You reach for the fewest, finest things — alabaster, linen, one honest brass line. Nothing shouts; everything holds. Your light is poured, not hung — warm from within, soft at the edge. A room in your signature reads calm before it reads designed — and by evening it simply glows, then stops.',
      plateGrad: 'radial-gradient(120% 110% at 62% 26%, #4a3f2e 0%, #2E2820 50%, #211C16 100%)',
      palette: [{ name: 'Cream', color: '#E8E0CE' }, { name: 'Sand', color: '#B6A484' }, { name: 'Warm brass', color: '#B08D4C' }, { name: 'Linen', color: '#D8CDB6' }] },
    ec: { key: 'ec', slug: 'evening-cinematic', name: 'The Evening Cinematic', edition: 'No. 02 of 06', moodShort: 'Evening Cinematic', mood: 'moody-cinematic',
      tagline: 'Low light — long shadow.',
      description: 'You light for the hour after sundown — smoked glass, low amber, a shadow that means to be there. Nothing is bright for its own sake; every source is placed. Your rooms read like a held breath — warm, close, cinematic. The fixture isn’t the point — the pool of light it throws is.',
      plateGrad: 'radial-gradient(120% 110% at 60% 30%, #3a2c18 0%, #2E2820 52%, #211C16 100%)',
      palette: [{ name: 'Charcoal', color: '#2E2820' }, { name: 'Amber', color: '#B87A3C' }, { name: 'Bronze', color: '#6E5228' }, { name: 'Smoke', color: '#4A4034' }] },
    gr: { key: 'gr', slug: 'gilded-romantic', name: 'The Gilded Romantic', edition: 'No. 03 of 06', moodShort: 'Gilded Romantic', mood: 'moody-cinematic',
      tagline: 'Crystal — and the drama it earns.',
      description: 'You believe a room deserves an occasion — crystal, tiered brass, the confident glamour of Deco. Light, to you, is meant to be caught and thrown back. Your rooms sparkle without apology — champagne and gold, warm and worn just enough. Restraint is lovely — but so is a chandelier that knows its worth.',
      plateGrad: 'radial-gradient(120% 110% at 60% 26%, #5a4a2a 0%, #33291a 54%, #211C16 100%)',
      palette: [{ name: 'Champagne', color: '#E6D6A8' }, { name: 'Crystal', color: '#DCCFC0' }, { name: 'Gold', color: '#C9A24B' }, { name: 'Rose brass', color: '#B98E5A' }] },
    cl: { key: 'cl', slug: 'classicist', name: 'The Classicist', edition: 'No. 04 of 06', moodShort: 'Classicist', mood: 'warm-minimal',
      tagline: 'Made to outlast the room.',
      description: 'You build for permanence — heritage silhouettes, patina brass, forms that were right a century ago and stay right. Nothing here is trend; everything is chosen to age. Your light is honest and unhurried — ivory and deep brown, warm as an old library. You don’t decorate a room — you settle it.',
      plateGrad: 'radial-gradient(120% 110% at 60% 32%, #443a2b 0%, #2a2318 54%, #211C16 100%)',
      palette: [{ name: 'Ivory', color: '#E8E0CE' }, { name: 'Patina', color: '#6E8B86' }, { name: 'Deep brown', color: '#5C4A34' }, { name: 'Aged brass', color: '#A5824A' }] },
    ls: { key: 'ls', slug: 'light-seeker', name: 'The Light Seeker', edition: 'No. 05 of 06', moodShort: 'Light Seeker', mood: 'bright-airy',
      tagline: 'Airy, open — morning-lit.',
      description: 'You chase the daylight and keep it — airy whites, pale oak, the soft blue-grey of morning by the coast. Your rooms breathe; light moves through them rather than pooling. Fixtures stay quiet and open, more air than object. When the sun goes, the warmth stays — low, clean, and never heavy.',
      plateGrad: 'radial-gradient(120% 110% at 60% 28%, #6a6c66 0%, #3a3d3a 52%, #211C16 100%)',
      palette: [{ name: 'Paper', color: '#F4EFE3' }, { name: 'Pale oak', color: '#CFC3A8' }, { name: 'Blue-grey', color: '#9FAAA6' }, { name: 'Bone', color: '#E8E0CE' }] },
    sm: { key: 'sm', slug: 'sculptural-modernist', name: 'The Sculptural Modernist', edition: 'No. 06 of 06', moodShort: 'Sculptural Modernist', mood: 'bright-airy',
      tagline: 'Form first — light as line.',
      description: 'You read a room as composition first — a contemporary line, an acrylic ribbon, an LED drawn like a gesture. Light, for you, is form made visible. Your rooms are spare and deliberate — bone and graphite, the statement doing the talking. One right object — and the wall around it goes quiet.',
      plateGrad: 'radial-gradient(120% 110% at 60% 30%, #4a463d 0%, #2a2822 54%, #211C16 100%)',
      palette: [{ name: 'Bone', color: '#CFC3A8' }, { name: 'Graphite', color: '#40382E' }, { name: 'Clear', color: '#D9CFC4' }, { name: 'Steel', color: '#6B6A66' }] }
  };
  var ORDER = ['wm', 'ec', 'gr', 'cl', 'ls', 'sm'];
  var BY_SLUG = {};
  ORDER.forEach(function (k) { BY_SLUG[ARCH[k].slug] = k; });

  /* ── scoring (design-exact: highest total, fixed-order tie-break) ── */
  function score(answers) {
    var sc = { wm: 0, ec: 0, gr: 0, cl: 0, ls: 0, sm: 0 };
    answers.forEach(function (a) {
      var w = a.w || {};
      Object.keys(w).forEach(function (k) { sc[k] += w[k]; });
    });
    return sc;
  }
  function winner(answers) {
    var sc = score(answers), best = null, bv = -1;
    ORDER.forEach(function (k) { if (sc[k] > bv) { bv = sc[k]; best = k; } });
    return best || 'wm';
  }

  /* ── storage ── */
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch (e) { return null; } }
  function write(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }

  /* ── els ── */
  function $(sel) { return root.querySelector(sel); }
  var els = {
    screens: {
      intro: $('[data-nvq-screen="intro"]'),
      question: $('[data-nvq-screen="question"]'),
      reveal: $('[data-nvq-screen="reveal"]'),
      result: $('[data-nvq-screen="result"]')
    },
    introNew: $('[data-nvq-intro-new]'),
    introReturn: $('[data-nvq-intro-returning]'),
    savedPalette: $('[data-nvq-saved-palette]'),
    savedName: $('[data-nvq-saved-name]'),
    step: $('[data-nvq-step]'),
    progress: $('[data-nvq-progress]'),
    palette: $('[data-nvq-palette]'),
    qtitle: $('[data-nvq-qtitle]'),
    qsub: $('[data-nvq-qsub]'),
    options: $('[data-nvq-options]'),
    revealPalette: $('[data-nvq-reveal-palette]'),
    plateBg: $('[data-nvq-plate-bg]'),
    edition: $('[data-nvq-edition]'),
    archName: $('[data-nvq-arch-name]'),
    archTagline: $('[data-nvq-arch-tagline]'),
    archDesc: $('[data-nvq-arch-desc]'),
    archPalette: $('[data-nvq-arch-palette]'),
    built: $('[data-nvq-built]'),
    builtSwatches: $('[data-nvq-built-swatches]'),
    shared: $('[data-nvq-shared]'),
    editBlock: $('[data-nvq-edit-block]'),
    mailWrap: $('[data-nvq-email]'),
    mailForm: $('[data-nvq-mail-form]'),
    mailSubmit: $('[data-nvq-mail-submit]'),
    mailInput: $('[data-nvq-mail-input]'),
    mailBtn: $('[data-nvq-mail-btn]'),
    mailError: $('[data-nvq-mail-error]'),
    mailErrorText: $('[data-nvq-mail-error-text]'),
    mailSuccess: $('[data-nvq-mail-success]'),
    mailSentTo: $('[data-nvq-mail-sent-to]'),
    moodName: $('[data-nvq-mood-name]'),
    studioLink: $('[data-nvq-studio-link]'),
    findOwn: $('[data-nvq-find-own]'),
    retakeResult: $('[data-nvq-retake-result]')
  };

  /* ── state ── */
  var state = { screen: 'intro', qi: 0, answers: [], shared: false, resultKey: 'wm' };
  var timers = [];
  function later(fn, ms) { timers.push(setTimeout(fn, ms)); }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function swatchSpan(sw, cls) {
    return '<span class="' + (cls || '') + '" title="' + esc(sw.name) + '" style="background:' + esc(sw.color) + ';"></span>';
  }

  /* ── screen switching ── */
  function show(name) {
    state.screen = name;
    Object.keys(els.screens).forEach(function (k) {
      if (els.screens[k]) els.screens[k].hidden = (k !== name);
    });
    var y = root.getBoundingClientRect().top + window.scrollY - 90;
    if (name !== 'intro') window.scrollTo({ top: Math.max(0, y), behavior: 'auto' });
  }

  /* ── intro ── */
  function renderIntro() {
    var saved = read();
    var returning = !!(saved && saved.arch && ARCH[BY_SLUG[saved.arch]]);
    var heroBg = root.querySelector('.nvq-hero__bg');
    var heroImg = returning ? (IMG.heroB || IMG.heroA) : IMG.heroA;
    if (heroBg && heroImg) heroBg.style.backgroundImage = "linear-gradient(rgba(23,19,15,0.38), rgba(23,19,15,0.38)), url('" + heroImg + "')";
    els.introNew.hidden = returning;
    els.introReturn.hidden = !returning;
    if (returning) {
      var a = ARCH[BY_SLUG[saved.arch]];
      els.savedName.textContent = a.name;
      var pal = (saved.palette && saved.palette.length) ? saved.palette.slice(0, 4) : a.palette;
      els.savedPalette.innerHTML = pal.map(function (sw) { return swatchSpan(sw); }).join('');
    }
    track(returning ? 'viewed_returning' : 'viewed');
    show('intro');
  }

  /* ── question ── */
  function renderQuestion() {
    var q = QUESTIONS[state.qi];
    els.step.textContent = 'Question ' + (state.qi + 1) + ' of ' + TOTAL;
    els.progress.style.width = Math.round(((state.qi + 1) / TOTAL) * 100) + '%';

    var slots = '';
    for (var i = 0; i < TOTAL; i++) {
      var a = state.answers[i];
      slots += a ? swatchSpan(a.swatch, 'is-filled') : '<span class="is-empty"></span>';
    }
    els.palette.innerHTML = slots;

    els.qtitle.textContent = q.title;
    els.qsub.textContent = q.sub || '';

    var html = '';
    if (q.kind === 'pair') {
      html += '<div class="nvq-pair">';
      q.options.forEach(function (o) {
        html += '<button type="button" class="nvq-pair__cell" data-nvq-opt="' + o.id + '">' +
          '<span class="nvq-pair__img" style="' + bgLayers(o.id, o.grad) + '"></span>' +
          (IMG[o.id] ? '' : '<span class="nvq-pair__lattice" aria-hidden="true"></span>') +
          '<span class="nvq-pair__scrim" aria-hidden="true"></span>' +
          '<span class="nvq-pair__caption"><span class="nvq-pair__kicker">' + esc(o.kicker) + '</span>' +
          '<span class="nvq-pair__label">' + esc(o.label) + '</span></span>' +
          '</button>';
      });
      html += '<div class="nvq-pair__or"><span>or</span></div></div>';
    } else if (q.kind === 'grid') {
      html += '<div class="nvq-grid"><div class="nvq-grid__wrap">';
      q.options.forEach(function (o) {
        html += '<button type="button" class="nvq-grid__cell" data-nvq-opt="' + o.id + '">' +
          '<span class="nvq-pair__img" style="' + bgLayers(o.id, o.grad) + '"></span>' +
          (IMG[o.id] ? '' : '<span class="nvq-pair__lattice" aria-hidden="true"></span>') +
          '<span class="nvq-pair__scrim" aria-hidden="true"></span>' +
          '<span class="nvq-grid__label">' + esc(o.label) + '</span>' +
          '</button>';
      });
      html += '</div></div>';
    } else {
      html += '<div class="nvq-stage"><div class="nvq-stage__wrap">';
      q.options.forEach(function (o) {
        html += '<button type="button" class="nvq-stage__cell" data-nvq-opt="' + o.id + '">' +
          '<span class="nvq-stage__row">' +
          '<span class="nvq-stage__dot" style="background:' + esc(o.swatch.color) + ';"></span>' +
          '<span class="nvq-stage__copy"><span class="nvq-stage__label">' + esc(o.label) + '</span>' +
          '<span class="nvq-stage__sub">' + esc(o.sub) + '</span></span>' +
          '<svg class="nvq-stage__arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>' +
          '</span></button>';
      });
      html += '</div></div>';
    }
    els.options.innerHTML = html;
    track('q' + (state.qi + 1));
    show('question');
  }

  function pick(oid) {
    var q = QUESTIONS[state.qi];
    var o = null;
    q.options.forEach(function (x) { if (x.id === oid) o = x; });
    if (!o) return;

    var cell = els.options.querySelector('[data-nvq-opt="' + oid + '"]');
    if (cell) {
      cell.classList.add('is-selected');
      cell.insertAdjacentHTML('beforeend',
        '<span class="nvq-pick-ring" aria-hidden="true"></span>' +
        '<span class="nvq-pick-check" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke-width="2.4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>');
    }

    later(function () {
      var answers = state.answers.slice(0, state.qi);
      answers.push({ qid: state.qi, optionId: oid, swatch: o.swatch, w: o.w });
      state.answers = answers;
      if (state.qi < TOTAL - 1) {
        state.qi += 1;
        renderQuestion();
      } else {
        renderReveal();
      }
    }, 480);
  }

  function back() {
    if (state.qi > 0) { state.qi -= 1; renderQuestion(); }
    else renderIntro();
  }

  /* ── reveal ── */
  function renderReveal() {
    els.revealPalette.innerHTML = state.answers.map(function (a, i) {
      return '<span title="' + esc(a.swatch.name) + '" style="background:' + esc(a.swatch.color) + ';animation-delay:' + (0.15 * i) + 's;"></span>';
    }).join('');
    track('reveal');
    show('reveal');
    later(function () {
      state.resultKey = winner(state.answers);
      persistResult();
      renderResult({ shared: false });
    }, 2200);
  }

  function answerId(qi) {
    var a = state.answers[qi];
    return a ? a.optionId : '';
  }

  function persistResult() {
    var saved = read() || {};
    write({
      arch: ARCH[state.resultKey].slug,
      light: answerId(4),
      room: answerId(5),
      stage: answerId(6),
      palette: state.answers.map(function (a) { return a.swatch; }),
      subscribed: !!saved.subscribed,
      ts: Date.now()
    });
  }

  /* ── intent-aware edit selection (clean room:/scale: tags) ──
     The archetype picks the collection; the shopper's Q5 (light-style) + Q6 (room)
     pick which 4 pieces surface. Room is a real ELIGIBILITY gate now (the product's
     `room:<room>` tag), and pieces are RANKED by which fixture types lead that room
     (agreed rubric) + scale fit + light-style — so a bath edit leads with
     sconces/ceiling and never a statement chandelier (those carry no room:bath). */
  var ROOM_LABEL = { dining: 'the dining room', living: 'the living room', bedroom: 'the bedroom', bath: 'the bath', kitchen: 'the kitchen', entry: 'the entry & stair', office: 'the office' };
  // fixture types that LEAD each room (earlier in the list = stronger)
  var ROOM_LEAD = {
    bath:    ['Wall Light', 'Wall Lamp', 'Wall Sconce', 'Ceiling Light', 'Ceiling Lamp', 'Downlight', 'Mirror'],
    dining:  ['Chandelier', 'Pendant Light', 'Pendant', 'Ceiling Light', 'Ceiling Lamp'],
    living:  ['Chandelier', 'Pendant Light', 'Floor Lamp', 'Wall Lamp', 'Ceiling Light'],
    bedroom: ['Pendant Light', 'Wall Lamp', 'Table Lamp', 'Chandelier', 'Ceiling Light'],
    kitchen: ['Pendant Light', 'Ceiling Light', 'Downlight', 'Track Light'],
    entry:   ['Chandelier', 'Pendant Light', 'Wall Lamp', 'Ceiling Light'],
    office:  ['Table Lamp', 'Floor Lamp', 'Pendant Light', 'Ceiling Light']
  };
  function tagHas(tags, t) { return ('|' + tags + '|').indexOf('|' + t + '|') > -1; }
  function scaleOf(tags) { return tagHas(tags, 'scale:statement') ? 'statement' : (tagHas(tags, 'scale:accent') ? 'accent' : 'midscale'); }

  function pickEdit(grid, light, room) {
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.nvq-card'));
    if (!cards.length) return;
    var lead = ROOM_LEAD[room] || [];
    function score(c, i) {
      var t = c.getAttribute('data-ptype') || '';
      var tags = c.getAttribute('data-rtags') || '';
      var sc = scaleOf(tags), s = 0;
      var li = lead.indexOf(t);
      if (li > -1) s += (lead.length - li) * 2;                 // room-appropriate fixture type
      if (room === 'bath') { s += (sc === 'accent' ? 3 : sc === 'midscale' ? 1 : -3); }
      else if (room === 'dining' || room === 'entry') { s += (sc === 'statement' ? 2 : sc === 'midscale' ? 1 : 0); }
      if (light === 'layered') { if (t === 'Chandelier') s -= 3; if (li > -1 && t !== 'Chandelier') s += 1; }
      if (light === 'statement') { if (t === 'Chandelier') s += 2; if (t === 'Pendant Light') s += 1; }
      return s;
    }
    var roomTag = room ? ('room:' + room) : '';
    var eligible = [], rest = [];
    cards.forEach(function (c, i) {
      var ok = !roomTag || tagHas(c.getAttribute('data-rtags') || '', roomTag);
      (ok ? eligible : rest).push({ c: c, i: i });
    });
    function rank(list) {
      return list.map(function (x) { return { c: x.c, s: score(x.c, x.i), i: x.i }; })
                 .sort(function (a, b) { return b.s - a.s || a.i - b.i; });
    }
    var picks = rank(eligible);
    if (picks.length < 4) picks = picks.concat(rank(rest));    // graceful fill if a room is thin
    // type diversity: at most 2 of the same fixture type in the visible 4, so the
    // edit reads curated (2 sconces + a ceiling + a vanity piece) not 4 identical.
    var chosen = [], counts = {}, leftover = [];
    picks.forEach(function (x) {
      var t = x.c.getAttribute('data-ptype') || '';
      if (chosen.length < 4 && (counts[t] || 0) < 2) { chosen.push(x); counts[t] = (counts[t] || 0) + 1; }
      else leftover.push(x);
    });
    while (chosen.length < 4 && leftover.length) chosen.push(leftover.shift());
    cards.forEach(function (c) { c.hidden = true; });
    chosen.slice(0, 4).forEach(function (x) { x.c.hidden = false; });
  }

  /* ── result ── */
  function renderResult(opts) {
    var shared = !!(opts && opts.shared);
    var k = state.resultKey;
    var a = ARCH[k];
    var saved = read() || {};

    els.plateBg.style.background = a.plateGrad;
    els.edition.textContent = a.edition;
    els.archName.textContent = a.name;
    els.archTagline.textContent = a.tagline;
    els.archDesc.textContent = a.description;
    els.archPalette.innerHTML = a.palette.map(function (sw) {
      return '<div><span class="nvq-sw" style="background:' + esc(sw.color) + ';"></span><span class="nvq-sw-name">' + esc(sw.name) + '</span></div>';
    }).join('');

    var built = shared ? [] : (state.answers.length ? state.answers.map(function (x) { return x.swatch; }) : (saved.palette || []));
    els.built.hidden = shared || built.length === 0;
    if (!els.built.hidden) els.builtSwatches.innerHTML = built.map(function (sw) { return swatchSpan(sw); }).join('');
    els.shared.hidden = !shared;

    /* curated edit: show the winning archetype's grid, hide the block if empty */
    var anyProducts = false;
    var colUrl = '/collections/all';
    var light = state.answers.length ? answerId(4) : (saved.light || '');
    var room = state.answers.length ? answerId(5) : (saved.room || '');
    root.querySelectorAll('[data-nvq-edit]').forEach(function (grid) {
      var mine = grid.getAttribute('data-nvq-edit') === a.slug;
      grid.hidden = !mine;
      if (mine && grid.children.length > 0) {
        anyProducts = true;
        colUrl = grid.getAttribute('data-url') || colUrl;
        if (!shared) pickEdit(grid, light, room);
      }
    });
    els.editBlock.hidden = !anyProducts;

    /* intent note under the edit title */
    var note = root.querySelector('[data-nvq-edit-note]');
    if (note) {
      var bits = [];
      if (light === 'layered') bits.push('layered, quiet light');
      if (light === 'statement') bits.push('one statement piece');
      if (room && ROOM_LABEL[room]) bits.push(ROOM_LABEL[room]);
      note.hidden = shared || bits.length === 0;
      if (!note.hidden) note.textContent = 'Tuned to your picks — ' + bits.join(' · ');
    }
    root.querySelectorAll('[data-nvq-collection-link]').forEach(function (l) { l.href = colUrl; });

    /* email block: only for visitors whose email we DON'T already have.
       Logged-in customers (members get 15% — a 10% ask insults them) skip it;
       we still capture their signature to Klaviyo silently, below. Also skip if
       they already gave an email via this quiz or the popup on this device. */
    var custEmail = root.dataset.customerEmail || '';
    var popupState = '';
    try { popupState = (JSON.parse(localStorage.getItem(POPUP_KEY)) || {}).status || ''; } catch (e) {}
    var knownEmail = root.dataset.hasEmail === 'true' || popupState === 'subscribed' || popupState === 'known';
    els.mailWrap.hidden = shared || !!saved.subscribed || knownEmail;
    els.mailForm.hidden = false;
    els.mailSuccess.hidden = true;
    els.mailError.hidden = true;

    /* studio handoff */
    var mood = a.mood;
    if (k === 'ls' && (state.answers.length ? answerId(5) === 'bath' : saved.room === 'bath')) mood = 'coastal-calm';
    els.moodName.textContent = a.moodShort;
    var base = root.getAttribute('data-studio-url') || '/pages/studio';
    els.studioLink.href = base + (base.indexOf('?') > -1 ? '&' : '?') + 'mood=' + encodeURIComponent(mood) + '&via=quiz';
    var micro = root.querySelector('.nvq-handoff__micro');
    if (micro) {
      if (root.dataset.member === 'true') micro.textContent = 'Included with your Nava Circle membership';
      else if (custEmail) micro.textContent = 'You’re signed in — your first design is free';
    }

    /* footer */
    els.findOwn.hidden = !shared;
    els.retakeResult.hidden = shared;

    /* instrumentation: completion (anonymous funnel) + identified capture.
       For a logged-in customer the form is hidden, so this is the ONLY path
       that records their signature/room/stage — do not drop it. */
    track('completed', { archetype: a.slug });
    if (!shared && custEmail && !firedComplete) {
      firedComplete = true;
      var cp = completionProps();
      klProfile(custEmail, cp);
      klEvent(custEmail, 'Completed Lighting Quiz', { archetype: a.slug, room: cp.quiz_room, stage: cp.quiz_stage });
    }

    show('result');
  }

  /* ── email → Klaviyo (same mechanism as email-popup.liquid / footer.js) ── */
  function mailFail(msg) {
    els.mailErrorText.textContent = msg;
    els.mailError.hidden = false;
  }
  els.mailSubmit.addEventListener('submit', function (e) {
    e.preventDefault();
    els.mailError.hidden = true;
    var email = (els.mailInput.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { mailFail('Please enter a valid email address.'); els.mailInput.focus(); return; }

    var btnLabel = els.mailBtn.textContent;
    els.mailBtn.disabled = true; els.mailBtn.textContent = '…';

    var saved = read() || {};
    var props = {
      signup_source: 'quiz',
      lighting_signature: ARCH[state.resultKey].slug,
      quiz_room: state.answers.length ? answerId(5) : (saved.room || ''),
      quiz_stage: state.answers.length ? answerId(6) : (saved.stage || '')
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + root.dataset.company, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2026-07-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Lighting Signature Quiz',
            profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
          },
          relationships: { list: { data: { type: 'list', id: root.dataset.list } } }
        }
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('subscribe failed');
        var s = read() || {};
        s.subscribed = true;
        if (window.Nava && Nava.trackLead) Nava.trackLead('quiz');
        write(s);
        /* never popup at a quiz convert again (same key/shape as email-popup.liquid) */
        try { localStorage.setItem(POPUP_KEY, JSON.stringify({ status: 'subscribed' })); } catch (err) {}
        els.mailSentTo.textContent = email;
        els.mailForm.hidden = true;
        els.mailSuccess.hidden = false;
        /* now identified — mark the funnel + fire the countable completion event
           (the subscription above already set the profile properties) */
        track('emailed');
        clarityCall('set', 'nvq_emailed', 'true');
        if (!firedComplete) {
          firedComplete = true;
          klEvent(email, 'Completed Lighting Quiz', { archetype: ARCH[state.resultKey].slug, room: props.quiz_room, stage: props.quiz_stage });
        }
      })
      .catch(function () {
        els.mailBtn.disabled = false; els.mailBtn.textContent = btnLabel;
        mailFail('Something went wrong. Please try again.');
      });
  });

  /* ── wiring ── */
  root.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-nvq-opt]');
    if (opt && state.screen === 'question' && !opt.classList.contains('is-selected')) { pick(opt.getAttribute('data-nvq-opt')); return; }
    if (e.target.closest('[data-nvq-begin]')) { track('started'); state.qi = 0; state.answers = []; renderQuestion(); return; }
    if (e.target.closest('[data-nvq-studio-link]')) { track('studio_click'); return; } /* anchor still navigates */
    if (e.target.closest('[data-nvq-back]')) { back(); return; }
    if (e.target.closest('[data-nvq-retake]') || e.target.closest('[data-nvq-retake-result]')) {
      var s = read() || {};
      write({ subscribed: !!s.subscribed });
      state.qi = 0; state.answers = [];
      renderIntro();
      return;
    }
    if (e.target.closest('[data-nvq-see-edit]')) {
      var saved = read();
      if (saved && saved.arch && BY_SLUG[saved.arch]) {
        state.resultKey = BY_SLUG[saved.arch];
        state.answers = [];
        renderResult({ shared: false });
      }
      return;
    }
  });

  /* ── boot: ?sig deep link > saved > fresh ── */
  var params = new URLSearchParams(location.search);
  var sig = params.get('sig');
  if (sig && BY_SLUG[sig]) {
    state.resultKey = BY_SLUG[sig];
    state.shared = true;
    renderResult({ shared: true });
  } else {
    renderIntro();
  }

  /* test hooks. NOTE: the design's original cl/ls/sm fixtures tied into gr/wm/gr
     under its own scorer (never executed there); these are corrected paths,
     each verified to land its archetype with strictly-highest score. */
  window.NVQ = {
    score: score,
    winner: winner,
    questions: QUESTIONS,
    archetypes: ARCH,
    fixtures: {
      wm: [[0, 'airy'], [1, 'alab'], [2, 'brass'], [3, 'sculpt'], [4, 'layered'], [5, 'bedroom'], [6, 'finish']],
      ec: [[0, 'candle'], [1, 'crystal'], [2, 'steel'], [3, 'classic'], [4, 'statement'], [5, 'dining'], [6, 'dream']],
      gr: [[0, 'candle'], [1, 'crystal'], [2, 'brass'], [3, 'classic'], [4, 'statement'], [5, 'entry'], [6, 'finish']],
      cl: [[0, 'candle'], [1, 'alab'], [2, 'brass'], [3, 'classic'], [4, 'layered'], [5, 'living'], [6, 'reno']],
      ls: [[0, 'airy'], [1, 'alab'], [2, 'steel'], [3, 'classic'], [4, 'layered'], [5, 'bath'], [6, 'dream']],
      sm: [[0, 'airy'], [1, 'crystal'], [2, 'steel'], [3, 'sculpt'], [4, 'statement'], [5, 'entry'], [6, 'reno']]
    },
    runFixture: function (key) {
      var fx = this.fixtures[key];
      if (!fx) return null;
      var answers = fx.map(function (pair) {
        var q = QUESTIONS[pair[0]], o = null;
        q.options.forEach(function (x) { if (x.id === pair[1]) o = x; });
        return { qid: pair[0], optionId: pair[1], swatch: o.swatch, w: o.w };
      });
      return winner(answers);
    }
  };
})();
